const patientList = [
  {
    PatientID: "100090",
    FirstName: "Dave",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  },
  {
    PatientID: "100091",
    FirstName: "Shane",
    LastName: "Watson",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  },
  {
    PatientID: "100092",
    FirstName: "Michael",
    LastName: "Clark",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  },
  {
    PatientID: "100093",
    FirstName: "Dave",
    LastName: "Waymouth",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  },
  {
    PatientID: "100094",
    FirstName: "Ariana",
    LastName: "Andrews",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  },
  {
    PatientID: "100095",
    FirstName: "Melora",
    LastName: "Timberlake",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  },
  {
    PatientID: "100096",
    FirstName: "Lona",
    LastName: "Rhodes",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  },
  {
    PatientID: "100097",
    FirstName: "Marcus",
    LastName: "Stokes",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  },
  {
    PatientID: "100098",
    FirstName: "Andrew",
    LastName: "Tye",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  },
  {
    PatientID: "100099",
    FirstName: "Robin",
    LastName: "Taylor",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    notes: 'Very Sick',
    relatives: [
      {
        patientId: "",
        relation: ""
      }
    ],
    alternateAgents: [{
      agent_firstname: 'agent_firstname',
      agent_lastname: 'agent_lastname',
      agent_email: 'agenttest@email.com',
      agent_sms: '1234567890',
      isdefault: false,
    }]
  }

];

const rxList = [
  {
    ndcCode: "42681-7076",
    itemId: "03",
    binId: "A3",
    rxNo: "A123456",
    name: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
    description: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 10,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    strength: "500 mg/1",
    route: "Oral",
    doseage_form: "Tablet",
    non_proprietary_name: "Amoxicillan",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "42681-7075",
    itemId: "03",
    binId: "A3",
    rxNo: "A123457",
    name: "Eliquis 2.5 mg Tab",
    description: "Eliquis 2.5 mg Tab",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 90,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    strength: "10 mg/1",
    route: "Oral",
    doseage_form: "Tablet, Film Coated",
    non_proprietary_name: "atorvastatin calcium",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "42681-7077",
    itemId: "03",
    binId: "A3",
    rxNo: "A123458",
    name: "Mounjaro 7.5 mg/0.5 mL pen for injection",
    description: "Mounjaro 7.5 mg/0.5 mL pen for injection",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 30,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    strength: "500 mg/1",
    route: "Oral",
    doseage_form: "Tablet, Film Coated",
    non_proprietary_name: "valacyclovir hydrochloride",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "10202-0484",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "lidocaine Top 4% Cream 30 gm",
    description: "lidocaine Top 4% Cream 30 gm",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "10202-0259",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
    description: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "10202-0416",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
    description: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "10202-0130",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "Eliquis 2.5 mg Tab",
    description: "Eliquis 2.5 mg Tab",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "42507-0217",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "Mounjaro 7.5 mg/0.5 mL pen for injection",
    description: "Mounjaro 7.5 mg/0.5 mL pen for injection",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "16590-0323",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "lidocaine Top 4% Cream 30 gm",
    description: "lidocaine Top 4% Cream 30 gm",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "16590-0745",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
    description: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "21695-0002",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
    description: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "21695-0003",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "Eliquis 2.5 mg Tab",
    description: "Eliquis 2.5 mg Tab",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "24236-0279",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "Mounjaro 7.5 mg/0.5 mL pen for injection",
    description: "Mounjaro 7.5 mg/0.5 mL pen for injection",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  },
  {
    ndcCode: "24236-0792",
    itemId: "03",
    binId: "A3",
    rxNo: "A123459",
    name: "lidocaine Top 4% Cream 30 gm",
    description: "lidocaine Top 4% Cream 30 gm",
    image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
    potency: "500 mg/1",
    qty: 15,
    schedule: "",
    Amount: 5,
    taxPercentage: 3,
    insuranceAmount: 0,
    CoPayAmount: 5,
    PaidAmount: 5,
    DueAmount: 0,
    paymentDueDate: "",
    stockedOn: "",
    stockedBy: "",
    deStockedOn: "",
    ExpirationDate: "01/01/2020"
  }

]

module.exports =
{
  randomPatient: function () {
    const patient = patientList[Math.floor(Math.random() * patientList.length)];
    return patient;
  },
  randomRx: function () {
    const rx = rxList[Math.floor(Math.random() * rxList.length)];
    return rx;
  },
  /**
   * A55 test Rx: independent random flags each scan (~50% each).
   * Controlled substance and consult required are rolled separately.
   */
  getA55DemoRxFlags: function (rxNo) {
    const isControlled = Math.random() < 0.5;
    const isConsultRequired = Math.random() < 0.5;
    const flags = {
      is_controlled_substance: isControlled,
      ConsultRequire: isConsultRequired,
      is_consultrequire: isConsultRequired,
    };
    if (process.env.NODE_ENV !== 'production') {
      console.log('[A55 Demo] getA55DemoRxFlags', {
        rxNo: String(rxNo || ''),
        is_controlled_substance: isControlled,
        ConsultRequire: isConsultRequired,
        is_consultrequire: isConsultRequired,
      });
    }
    return flags;
  },
}



// WEBPACK FOOTER //
// ./src/components/common/demo-data.js